import { useAtomValue, useSetAtom } from "jotai"
import React, { useEffect, useRef } from "react"
import { ModalForm } from "@ant-design/pro-form"
import { Button } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import axiosApiInstance from "../../../../api/axiosClient"
import { useNavigate, useParams } from "react-router-dom"
import { queryClientAtom } from "jotai-tanstack-query"
import { ActionType } from "@ant-design/pro-table"

const REDIRECT_URL = `/music/asset_labels/`

const DeleteAssetLabelForm = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const queryClient = useAtomValue(queryClientAtom)


  return (
    <ModalForm
      open
      width={400}
      title={`Delete Asset Label: ${id}`}
      submitter={{ submitButtonProps: { danger: true } }}
      autoFocusFirstInput
      modalProps={{
        destroyOnClose: true,
        okText: "Delete",
        cancelText: "No",
        onCancel: () => navigate(REDIRECT_URL),
      }}
      // onFinish={() => {navigate(REDIRECT_URL); return Promise.resolve()}}
      onFinish={async (values) => {
        return axiosApiInstance
          .delete(`/api/products/asset_labels/${id}`)
          .then((res) => {
            queryClient.invalidateQueries({ queryKey: ["asset_labels"] })
            navigate(REDIRECT_URL)
            return true
          })
          .catch((reason) => {
            console.log(reason)
          })
      }}
    >
      Are you sure?
    </ModalForm>
  )
}

export default DeleteAssetLabelForm
